import LoginNavigation from '@routes/components/LoginNavigation';
import React from 'react';

const LoginNavigationContainer = () => {
  return <LoginNavigation />;
};

export default LoginNavigationContainer;
